import { TableCell } from "@/components/ui/table"
import { UserDisplay } from "@/components/user-display"
import type { Project } from "@/types"

export function ContactCell({ project }: { project: Project }) {
  const user = project.created_by

  return (
    <TableCell>
      {user ? (
        <div className="flex items-center gap-2">
          <UserDisplay user={user} size="sm" avatarOnly />
          <div className="flex flex-col">
            <span className="text-sm">
              {user.first_name} {user.last_name}
            </span>
            {project.assigned_teams && project.assigned_teams.length > 0 && (
              <span className="text-muted-foreground text-xs">
                {project.assigned_teams.map((t) => t.name).join(", ")}
              </span>
            )}
          </div>
        </div>
      ) : (
        "—"
      )}
    </TableCell>
  )
}
